import { Platform } from "react-native";

let AsyncStorage: any = null;

// Only import AsyncStorage on native — on web we use localStorage directly
if (Platform.OS !== "web") {
  try {
    AsyncStorage = require("@react-native-async-storage/async-storage").default;
  } catch {}
}

export async function setItem(key: string, value: string) {
  if (Platform.OS === "web") {
    try { localStorage.setItem(key, value); } catch {}
  } else if (AsyncStorage) {
    await AsyncStorage.setItem(key, value);
  }
}

export async function getItem(key: string): Promise<string | null> {
  if (Platform.OS === "web") {
    try { return localStorage.getItem(key); } catch { return null; }
  } else if (AsyncStorage) {
    return AsyncStorage.getItem(key);
  }
  return null;
}

export async function removeItem(key: string) {
  if (Platform.OS === "web") {
    try { localStorage.removeItem(key); } catch {}
  } else if (AsyncStorage) {
    await AsyncStorage.removeItem(key);
  }
}
